import type { FaireProductEntity } from "../../entity_types/product";

export const p_3axik004e1: FaireProductEntity = {
  token: "p_3axik004e1",
  type: "product",
  name: "Matcha Bowl w/ Spout (Katakuchi Chawan)",
  brandToken: "b_cj9aq68jgc",
  brandName: "ARTEAO Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/f0b3379d6ef5c80c2809065dc6fc81262b71aded973d70af81fba51548e0e2b9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0241a5ce6ccfad73fbcc72191b1aded52db2e96a3f9ddde62686acc65e48c63c.jpeg",
    "https://cdn.faire.com/fastly/0843b7c4777b1cf1015fccd807a0225f38956de60fab3a34c58958bd00aae8f4.jpeg",
    "https://cdn.faire.com/fastly/d54b02e3454fde89a79ebc0f5530a9455ffea8339ee1891c5820bc78c9289b4e.jpeg",
  ],
  priceDollars: 23.57,
  description:
    "Handmade Katakuchi Bowl from Killdear Pottery is a great tool for dispensing mixed Matcha and hot water to cups or mugs.\n\nFEATURES\n• Katakuchi Bowl: 5 x 2 1/2'' \n \nMAINTENANCE\n• Dishwasher safe ",
  tags: [],
  msrpDollars: 47.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-31T17:28:24.163Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
